import React, { useState } from 'react';
import './CourseDetail.css';
import CourseEnrollForm from '../CourseEnrollForm/CourseEnrollForm';

const COURSE_DATA = {
  Electronics: {
    category: 'Foundational',
    title: 'Electronics',
    subtitle: 'Build a strong foundation in electronic concepts and practical hardware skills.',
    badges: ['Duration: 4 months', 'Total Hours: 32 hrs', 'Sessions: 2 hrs/session (weekends)', 'Level: Foundational', 'Prerequisite: None'],
    learn: [
      'Basics of Energy, Voltage, Current & Power',
      'Electronic Components & Circuit Building',
      'Resistor Colour Coding & Measurements',
      'Breadboard & Multimeter Usage',
      'Series & Parallel Circuits',
      'Switches, Transistors & Potentiometers',
      'Capacitors & Voltage Regulators',
      'Water Level Indicator Project',
      'Basics of Digital Electronics & Relays',
      'Idea Creation & Project Presentation',
      'Revision & Assessment',
    ],
    schedule: { duration: '4 months', totalHours: '32 hrs', sessions: '2 hrs/session (weekends)', level: 'Foundational', prerequisite: 'None' },
    tools: ['Breadboard & Jumpers', 'Multimeter', 'Soldering Tools', 'LEDs & Resistors', 'ICs & Components', 'Electronic Testing Tools'],
    modes: [
      { title: 'Offline', desc: 'All sessions at ibots centre. Equipment on-site. Kits not for takeaway.' },
      { title: 'Hybrid', desc: 'Online sessions + DIY kit for home practice. See sample kits →', highlighted: true },
    ],
  },
  'Embedded Systems': {
    category: 'Foundational',
    title: 'Embedded Systems',
    subtitle: 'Learn microcontroller programming with Arduino through real-time embedded projects.',
    badges: ['Duration: 4 months', 'Total Hours: 32 hrs', 'Sessions: 2 hrs/session (weekends)', 'Level: Foundational', 'Prerequisite: Electronics'],
    learn: [
      'Basics of Embedded Systems & Arduino',
      'C Programming Fundamentals',
      'Sensors & Real-Time Data Processing',
      'Motors, Servo & Automation Control',
      'Communication Protocols (I2C, SPI, UART)',
      'Bluetooth & Wireless Communication',
      'RTOS Basics & Embedded Applications',
      'Smart Project Development with Arduino',
      'Project Presentation & Demo Day',
    ],
    schedule: { duration: '4 months', totalHours: '32 hrs', sessions: '2 hrs/session (weekends)', level: 'Foundational', prerequisite: 'Electronics' },
    tools: ['Arduino Programming', 'Embedded C', 'Displays & Interfaces', 'Electronic Components', 'Sensors & Modules', 'Breadboard'],
    modes: [
      { title: 'Offline', desc: 'All sessions at ibots centre. Equipment on-site. Kits not for takeaway.' },
      { title: 'Hybrid', desc: 'Online sessions + DIY kit for home practice. See sample kits →', highlighted: true },
    ],
  },
  IoT: {
    category: 'Foundational',
    title: 'IoT',
    subtitle: 'Connect and control smart devices using ESP32, Wi-Fi, and MQTT protocols.',
    badges: ['Duration: 4 months', 'Total Hours: 32 hrs', 'Sessions: 2 hrs/session (weekends)', 'Level: Foundational', 'Prerequisite: Embedded Systems'],
    learn: [
      'Fundamentals of IoT & Smart Devices',
      'ESP8266/ESP32 Programming',
      'Sensor Integration & Data Monitoring',
      'Wi-Fi, Bluetooth & MQTT Communication',
      'Cloud & Blynk App Integration',
      'Web-Based Device Control',
      'Smart Automation Projects',
      'Real-Time Monitoring Systems',
      'Project Presentation & Demo Day',
    ],
    schedule: { duration: '4 months', totalHours: '32 hrs', sessions: '2 hrs/session (weekends)', level: 'Foundational', prerequisite: 'Embedded Systems' },
    tools: ['ESP8266 / ESP32', 'Sensor Modules', 'Wi-Fi & Bluetooth', 'Blynk Cloud', 'MQTT Protocol'],
    modes: [
      { title: 'Offline', desc: 'All sessions at ibots centre. Equipment on-site. Kits not for takeaway.' },
      { title: 'Hybrid', desc: 'Online sessions + DIY kit for home practice. See sample kits →', highlighted: true },
    ],
  },
  Robotics: {
    category: 'Foundational',
    title: 'Robotics',
    subtitle: 'Design, build, and program intelligent robotic systems.',
    badges: ['Duration: 4 months', 'Total Hours: 32 hrs', 'Sessions: 2 hrs/session (weekends)', 'Level: Foundational', 'Prerequisite: Embedded Systems'],
    learn: [
      'Arduino Programming Basics',
      'Circuit Building & Switch Control',
      'Sensors & Distance Measurement',
      'Motor & Speed Control',
      'Wi-Fi, RF & Bluetooth Communication',
      'Mobile App Integration',
      'Automation & Smart Control Systems',
      'Hands-on Robotics Projects',
      'Project Presentation & Demo Day',
    ],
    schedule: { duration: '4 months', totalHours: '32 hrs', sessions: '2 hrs/session (weekends)', level: 'Foundational', prerequisite: 'Embedded Systems' },
    tools: ['Servo & DC Motors', 'Motor Drivers', 'IR & Ultrasonic Sensors', 'Wi-Fi & Bluetooth', 'RF Communication', 'Mobile App Control'],
    modes: [
      { title: 'Offline', desc: 'All sessions at ibots centre. Equipment on-site. Kits not for takeaway.' },
      { title: 'Hybrid', desc: 'Online sessions + DIY kit for home practice. See sample kits →', highlighted: true },
    ],
  },
  'Little Innovator 1': {
    category: 'Age 6 & 7 · Little Innovator',
    title: 'Little Innovator 1',
    subtitle: 'A fun, play-based introduction to technology for children aged 6 & 7.',
    badges: ['Duration: 6 months', 'Total Hours: 48 hrs', 'Sessions: 2 hrs/session (weekends)', 'Level: Beginner', 'Age: 6 & 7'],
    learn: [
      'Basics of Electricity & Light',
      'Simple Circuit Building',
      'Magnets & Magnetic Fields',
      'Hands-on Experiments with LEDs',
      'Introduction to Sensors',
      'Play-based Science Activities',
      'Creative Building Projects',
      'Problem Solving Activities',
      'Teamwork & Presentation Skills',
      'Fun Project Showcase',
    ],
    schedule: { duration: '6 months', totalHours: '48 hrs', sessions: '2 hrs/session (weekends)', level: 'Beginner', prerequisite: 'None' },
    tools: ['Age 6 & 7', 'Module 1', 'Play-Based Learning', 'Grade 1–2'],
    modes: [
      { title: 'Offline', desc: 'All sessions at ibots centre. Equipment on-site. Kits not for takeaway.' },
      { title: 'Hybrid', desc: 'Online sessions + DIY kit for home practice. See sample kits →', highlighted: true },
    ],
  },
  'Little Innovator 2': {
    category: 'Age 6 & 7 · Little Innovator',
    title: 'Little Innovator 2',
    subtitle: 'Building on Module 1, children discover how everyday gadgets work.',
    badges: ['Duration: 6 months', 'Total Hours: 48 hrs', 'Sessions: 2 hrs/session (weekends)', 'Level: Beginner', 'Age: 6 & 7'],
    learn: [
      'How Everyday Gadgets Work',
      'Motors & Buzzers Experiments',
      'Basic Sensor Exploration',
      'Problem Solving Thinking',
      'Guided Experiments',
      'Creative Gadget Building',
      'Imaginative Exploration',
      'Science & Technology Fun',
      'Teamwork Projects',
      'Final Showcase & Presentation',
    ],
    schedule: { duration: '4 months', totalHours: '32 hrs', sessions: '2 hrs/session (weekends)', level: 'Beginner', prerequisite: 'Little Innovator 1' },
    tools: ['Age 6 & 7', 'Module 2', 'Curiosity & Exploration', 'Grade 1–2'],
    modes: [
      { title: 'Offline', desc: 'All sessions at ibots centre. Equipment on-site. Kits not for takeaway.' },
      { title: 'Hybrid', desc: 'Online sessions + DIY kit for home practice. See sample kits →', highlighted: true },
    ],
  },
  'Artificial Intelligence with Raspberry Pi': {
    category: 'Advanced Level',
    title: 'Artificial Intelligence with Raspberry Pi',
    subtitle: 'Learn AI fundamentals with Python and deploy models on Raspberry Pi.',
    badges: ['Duration: 4 months', 'Total Hours: 32 hrs', 'Sessions: 2 hrs/session (weekends)', 'Level: Advanced', 'Prerequisite: Python Basics'],
    learn: [
      'Introduction to Artificial Intelligence',
      'Python for AI & Machine Learning',
      'Neural Networks & Deep Learning',
      'Computer Vision with OpenCV',
      'TensorFlow & Model Training',
      'Edge AI Deployment on Raspberry Pi',
      'Face Recognition Projects',
      'Object Detection Systems',
      'Voice Recognition Basics',
      'Mini Project: AI-Powered Device',
      'Revision & Assessment',
    ],
    schedule: { duration: '4 months', totalHours: '32 hrs', sessions: '2 hrs/session (weekends)', level: 'Advanced', prerequisite: 'Python Basics' },
    tools: ['Raspberry Pi', 'Python', 'TensorFlow', 'OpenCV', 'Deep Learning'],
    modes: [
      { title: 'Offline', desc: 'All sessions at ibots centre. Equipment on-site. Kits not for takeaway.' },
      { title: 'Hybrid', desc: 'Online sessions + DIY kit for home practice. See sample kits →', highlighted: true },
    ],
  },
  'Drone Technology': {
    category: 'Advanced Level',
    title: 'Drone Technology',
    subtitle: 'Learn drone assembly, flight control systems and aerial robotics.',
    badges: ['Duration: 4 months', 'Total Hours: 32 hrs', 'Sessions: 2 hrs/session (weekends)', 'Level: Advanced', 'Prerequisite: Electronics'],
    learn: [
      'Basics & Applications of Drone Technology',
      'Drone Components & Flight Controllers',
      'ESCs, BLDC Motors & Power Systems',
      'GPS Navigation & Autonomous Flight',
      'Drone Programming & Mission Planning',
      'Flight Controls, PID Tuning & Stabilization',
      'FPV Cameras & Sensor Integration',
      'Drone Safety, Regulations & Troubleshooting',
      'Hands-on Flight Practice & Demo Day',
    ],
    schedule: { duration: '4 months', totalHours: '32 hrs', sessions: '2 hrs/session (weekends)', level: 'Advanced', prerequisite: 'Electronics' },
    tools: ['Flight Controllers', 'BLDC Motors & ESCs', 'Propellers & Frames', 'GPS & Sensors', 'FPV Camera', 'Drone Assembly & Calibration'],
    modes: [
      { title: 'Offline', desc: 'All sessions at ibots centre. Equipment on-site. Kits not for takeaway.' },
      { title: 'Hybrid', desc: 'Online sessions + DIY kit for home practice. See sample kits →', highlighted: true },
    ],
  },
  'AI & Tiny ML': {
    category: 'Advanced Level',
    title: 'AI & Tiny ML',
    subtitle: 'Deploy machine learning models on microcontrollers for real-time applications.',
    badges: ['Duration: 4 months', 'Total Hours: 32 hrs', 'Sessions: 2 hrs/session (weekends)', 'Level: Advanced', 'Prerequisite: Python Basics'],
    learn: [
      'Introduction to Artificial Intelligence & TinyML',
      'Basics of Machine Learning & Edge AI',
      'Data Collection, Processing & Model Training',
      'Microcontroller Programming for AI Applications',
      'Voice Detection & Gesture Recognition Systems',
      'Sensor Integration & Real-Time Decision Making',
      'Deploying AI Models on Embedded Hardware',
      'Building Smart Automation & Intelligent Projects',
      'Hands-on Project Development & Demo Day',
    ],
    schedule: { duration: '4 months', totalHours: '32 hrs', sessions: '2 hrs/session (weekends)', level: 'Advanced', prerequisite: 'Python Basics' },
    tools: ['TinyML & Edge AI', 'Machine Learning', 'AI Model Training', 'Microcontrollers', 'Voice Recognition'],
    modes: [
      { title: 'Offline', desc: 'All sessions at ibots centre. Equipment on-site. Kits not for takeaway.' },
      { title: 'Hybrid', desc: 'Online sessions + DIY kit for home practice. See sample kits →', highlighted: true },
    ],
  },
  '3D Design & Printing': {
    category: 'Advanced Level',
    title: '3D Design & Printing',
    subtitle: 'Learn 2D & 3D designing and hands-on 3D printing workflows.',
    badges: ['Duration: 4 months', 'Total Hours: 32 hrs', 'Sessions: 2 hrs/session (weekends)', 'Level: Advanced', 'Prerequisite: None'],
    learn: [
      'Fundamentals of 2D & 3D Designing',
      'AutoCAD, Fusion 360 & Blender Tools',
      '3D Modeling, Sketching & Rendering',
      'Product, Prototype & Enclosure Design',
      'Design Visualization & Creative Modeling',
      'Preparing Models for 3D Printing',
      '3D Printer Setup & Workflow Basics',
      'Hands-on Design Projects & Presentations',
    ],
    schedule: { duration: '4 months', totalHours: '32 hrs', sessions: '2 hrs/session (weekends)', level: 'Advanced', prerequisite: 'None' },
    tools: ['AutoCAD', 'Fusion 360', 'Blender', '3D Modeling', 'Product Design', 'Rendering & Visualization'],
    modes: [
      { title: 'Offline', desc: 'All sessions at ibots centre. Equipment on-site. Kits not for takeaway.' },
      { title: 'Hybrid', desc: 'Online sessions + DIY kit for home practice. See sample kits →', highlighted: true },
    ],
  },
  Mechatronics: {
    category: 'Advanced Level',
    title: 'Mechatronics',
    subtitle: 'Integrate mechanical, electrical, and software systems to build intelligent automated systems.',
    badges: ['Duration: 4 months', 'Total Hours: 32 hrs', 'Sessions: 2 hrs/session (weekends)', 'Level: Advanced', 'Prerequisite: Electronics'],
    learn: [
      'Fundamentals of Mechatronics Systems',
      'Integration of Mechanical, Electrical & Software Systems',
      'Sensors, Actuators & Control Mechanisms',
      'Motor Control, Drivers & Automation Concepts',
      'Microcontroller-Based System Design & Programming',
      'Smart Actuator Development & Control Logic',
      'Basics of Industrial Automation & Robotics Systems',
      'Hands-on Project Development & Real-World Applications',
    ],
    schedule: { duration: '4 months', totalHours: '32 hrs', sessions: '2 hrs/session (weekends)', level: 'Advanced', prerequisite: 'Electronics' },
    tools: ['Mechatronics Systems', 'Sensors & Actuators', 'Motor Control', 'Automation Systems'],
    modes: [
      { title: 'Offline', desc: 'All sessions at ibots centre. Equipment on-site. Kits not for takeaway.' },
      { title: 'Hybrid', desc: 'Online sessions + DIY kit for home practice. See sample kits →', highlighted: true },
    ],
  },
  'Customised Learning Path': {
    category: 'Flexible',
    title: 'Customised Learning Path',
    subtitle: 'Build a personalized skill development program tailored to your goals.',
    badges: ['Duration: On Request', 'Flexible Hours', 'Sessions: Customised', 'Level: Any', 'Prerequisite: Varies'],
    learn: [
      'Choose Your Own Technology Domains',
      'Set Your Preferred Duration',
      'Add Specializations & Custom Topics',
      'Multi-Domain Training Options',
      'Personalized Curriculum Design',
      'Flexible Schedule Planning',
      'One-on-One Mentorship',
      'Industry-Aligned Projects',
      'Career-Focused Learning Path',
      'Final Portfolio Project',
    ],
    schedule: { duration: 'On Request', totalHours: 'Flexible', sessions: 'Customised', level: 'Any Level', prerequisite: 'Varies' },
    tools: ['Custom Learning Path', 'Multi-Domain Training', 'Flexible Duration', 'Personalized Curriculum'],
    modes: [
      { title: 'Offline', desc: 'All sessions at ibots centre. Equipment on-site.' },
      { title: 'Hybrid', desc: 'Online sessions + DIY kit for home practice.', highlighted: true },
    ],
  },
  'STM32 Microcontroller': {
    category: 'Advanced Level',
    title: 'STM32 Microcontroller',
    subtitle: 'Learn advanced embedded system development using STM32 ARM Cortex-M microcontrollers.',
    badges: ['Duration: 4 months', 'Total Hours: 32 hrs', 'Sessions: 2 hrs/session (weekends)', 'Level: Advanced', 'Prerequisite: Embedded Systems'],
    learn: [
      'Introduction to STM32 ARM Cortex-M Microcontrollers',
      'Embedded C Programming with HAL Libraries',
      'GPIO, ADC, Timers, Interrupts & DMA',
      'Peripheral Interfacing & System Control',
      'RTOS Basics & Real-Time Application Concepts',
      'Sensor & Actuator Integration',
      'Debugging & Optimization Techniques',
      'Hands-on STM32-Based Project Development',
    ],
    schedule: { duration: '4 months', totalHours: '32 hrs', sessions: '2 hrs/session (weekends)', level: 'Advanced', prerequisite: 'Embedded Systems' },
    tools: ['STM32 Microcontrollers', 'ARM Cortex-M', 'Embedded C', 'HAL Libraries', 'GPIO & ADC'],
    modes: [
      { title: 'Offline', desc: 'All sessions at ibots centre. Equipment on-site. Kits not for takeaway.' },
      { title: 'Hybrid', desc: 'Online sessions + DIY kit for home practice. See sample kits →', highlighted: true },
    ],
  },
  'AI (Artificial Intelligence)': {
    category: 'Advanced Level',
    title: 'AI (Artificial Intelligence)',
    subtitle: 'Learn the fundamentals of Artificial Intelligence with a focus on deep learning, neural networks, and computer vision.',
    badges: ['Duration: 6 months', 'Total Hours: 48 hrs', 'Sessions: 2 hrs/session (weekends)', 'Level: Advanced', 'Prerequisite: Python Basics'],
    learn: [
      'Fundamentals of Artificial Intelligence & Machine Learning',
      'Python Programming for AI Development',
      'Deep Learning Concepts & Neural Network Architectures',
      'Data Handling, Training & Model Evaluation',
      'Computer Vision Techniques & Image Processing',
      'TensorFlow & AI Frameworks for Model Building',
      'Real-Time AI Applications & Optimization',
      'Deployment of AI Models on Raspberry Pi & Edge Devices',
      'End-to-End AI Project Development & Implementation',
    ],
    schedule: { duration: '6 months', totalHours: '48 hrs', sessions: '2 hrs/session (weekends)', level: 'Advanced', prerequisite: 'Python Basics' },
    tools: ['Artificial Intelligence', 'Deep Learning', 'Neural Networks', 'Python', 'TensorFlow'],
    modes: [
      { title: 'Offline', desc: 'All sessions at ibots centre. Equipment on-site. Kits not for takeaway.' },
      { title: 'Hybrid', desc: 'Online sessions + DIY kit for home practice. See sample kits →', highlighted: true },
    ],
  },
  'ROS / ROS2': {
    category: 'Advanced Level 2',
    title: 'ROS / ROS2',
    subtitle: 'Learn Robot Operating System for building intelligent robotic systems with SLAM and autonomous navigation.',
    badges: ['Duration: 6 months', 'Total Hours: 48 hrs', 'Sessions: 2 hrs/session (weekends)', 'Level: Advanced Level 2', 'Prerequisite: Robotics & Python'],
    learn: [
      'Introduction to ROS & ROS2 Architecture',
      'Basics of Robotics Middleware & Communication',
      'SLAM (Simultaneous Localization and Mapping)',
      'Autonomous Navigation & Path Planning',
      'Sensor Integration & Robot Perception',
      'Multi-Robot Coordination Concepts',
      'Simulation using Gazebo / RViz',
      'Hands-on Robotics Project Development',
    ],
    schedule: { duration: '6 months', totalHours: '48 hrs', sessions: '2 hrs/session (weekends)', level: 'Advanced Level 2', prerequisite: 'Robotics & Python' },
    tools: ['ROS', 'ROS2', 'SLAM', 'Autonomous Navigation', 'Path Planning'],
    modes: [
      { title: 'Offline', desc: 'All sessions at ibots centre. Equipment on-site. Kits not for takeaway.' },
      { title: 'Hybrid', desc: 'Online sessions + DIY kit for home practice. See sample kits →', highlighted: true },
    ],
  },
  'Innovation Engineers': {
    category: 'Innovation Engineers',
    title: 'Innovation Engineers',
    subtitle: 'A comprehensive multi-domain programme combining key contents from Electronics, Embedded Systems, IoT, and Robotics into one integrated learning journey.',
    badges: ['Duration: Custom timeline', 'Total Hours: 30 hrs', 'Sessions: 1–2 hrs/day', 'Level: Foundational to Advanced', 'Prerequisite: None'],
    learn: [
      'Fundamentals of Electronics — Resistors, LEDs, Capacitors & Circuit Building',
      'Microcontroller Programming with Arduino — GPIO, PWM, ADC & Sensors',
      'IoT Connectivity using ESP32, Wi-Fi, MQTT & Cloud Dashboards',
      'Robotics — Motor Control, Servo Systems & Automation',
      'Sensor Integration across multiple domains',
      'Hands-on Mini Projects for each domain',
      'Cross-domain System Integration',
      'Final Capstone Project combining all domains',
      'Project Presentation & Demo Day',
    ],
    schedule: { duration: 'Custom timeline', totalHours: '30 hrs', sessions: '1–2 hrs/day', level: 'Foundational to Advanced', prerequisite: 'None' },
    tools: ['Breadboard & Jumpers', 'Arduino', 'ESP32', 'Servo & DC Motors', 'IR & Ultrasonic Sensors', 'LEDs & Resistors', 'Soldering Tools'],
    modes: [
      { title: 'Offline', desc: 'All sessions at campus. Equipment provided by ibots.' },
      { title: 'Hybrid', desc: 'Online sessions + DIY kit. Kit charges apply.', highlighted: true },
    ],
  },
};

function CourseDetail({ courseName, onClose, trainingType = 'regular' }) {
  const [selectedMode, setSelectedMode] = useState('Hybrid');
  const [showEnrollForm, setShowEnrollForm] = useState(false);
  const course = COURSE_DATA[courseName];

  if (!course) return null;

  const durationOverride = {
    regular:           { duration: '6 months',      totalHours: '48 hrs', sessions: '2 hrs/session (weekends)' },
    intensive:         { duration: '15 days',        totalHours: '30 hrs', sessions: '2 hrs/session (daily)' },
    camp:              { duration: '7 days',         totalHours: '21 hrs', sessions: '3 hrs/session (daily)' },
    college:           { duration: '4 months',       totalHours: '32 hrs', sessions: '2 hrs/session (weekends)' },
    workshop:          { duration: '3–5 Days',       totalHours: '30 hrs', sessions: '6 hrs/day' },
    advanced_workshop: { duration: '3–5 Days',       totalHours: '30 hrs', sessions: '6 hrs/day' },
    vac:               { duration: 'Custom timeline', totalHours: '30 hrs', sessions: '1–2 hrs/day' },
  };

  const scheduleInfo = {
    ...course.schedule,
    ...durationOverride[trainingType],
    ...(trainingType === 'regular' && (courseName === 'Little Innovator 1' || courseName === 'Little Innovator 2') 
        ? { duration: '6 months', totalHours: '48 hrs' } 
        : {}),
  };

  return (
    <div className="cd__wrapper">
      <div className="cd__inner">

        {/* Header */}
        <div className="cd__header">
          <button className="cd__back" onClick={onClose}>‹ Back to courses</button>
          <span className="cd__category-badge">⚡ {course.category}</span>
          <h1 className="cd__title">{course.title}</h1>
          <p className="cd__subtitle">{course.subtitle}</p>
          <div className="cd__badges">
            {course.badges.map((b, i) => {
              if (b.startsWith('Duration:'))    return <span key={i} className="cd__badge">Duration: {scheduleInfo.duration}</span>;
              if (b.startsWith('Total Hours:')) return <span key={i} className="cd__badge">Total Hours: {scheduleInfo.totalHours}</span>;
              if (b.startsWith('Sessions:'))    return <span key={i} className="cd__badge">Sessions: {scheduleInfo.sessions}</span>;
              return <span key={i} className="cd__badge">{b}</span>;
            })}
          </div>
        </div>

        {/* Body */}
        <div className="cd__body">

          {/* Left */}
          <div className="cd__left">
            <div className="cd__section">
              <h3 className="cd__section-title"><span className="cd__section-icon">✏</span> WHAT YOU WILL LEARN</h3>
              <ul className="cd__learn-list">
                {course.learn.map((item, i) => (
                  <li key={i} className="cd__learn-item">
                    <span className="cd__check">✓</span>{item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="cd__divider" />

            <div className="cd__section">
              <h3 className="cd__section-title"><span className="cd__section-icon">■</span> TOOLS & HARDWARE</h3>
              <div className="cd__tools">
                {course.tools.map((t, i) => <span key={i} className="cd__tool">{t}</span>)}
              </div>
            </div>

            <div className="cd__divider" />

            <div className="cd__section">
              <h3 className="cd__section-title"><span className="cd__section-icon">🛡</span> TRAINING MODE</h3>
              <div className="cd__modes">
                {course.modes.map((m, i) => (
                  <div key={i}
                    className={`cd__mode-card ${selectedMode === m.title ? 'cd__mode-card--active' : ''}`}
                    onClick={() => setSelectedMode(m.title)}>
                    <p className="cd__mode-title">{m.title}</p>
                    <p className="cd__mode-desc">{m.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right — Schedule */}
          <div className="cd__right">
            <h3 className="cd__schedule-title"><span>■</span> SCHEDULE</h3>
            <div className="cd__schedule-table">
              {[
                { label: 'Duration',     value: scheduleInfo.duration },
                { label: 'Total Hours',  value: scheduleInfo.totalHours },
                { label: 'Sessions',     value: scheduleInfo.sessions },
                { label: 'Level',        value: scheduleInfo.level },
                { label: 'Prerequisite', value: scheduleInfo.prerequisite },
              ].map((row, i) => (
                <div key={i} className="cd__schedule-row">
                  <span className="cd__schedule-label">{row.label}</span>
                  <span className="cd__schedule-value">{row.value}</span>
                </div>
              ))}
            </div>
          </div>

        </div>

        {/* Enroll Banner */}
        <div className="cd__enroll-wrapper">
          <div className="cd__enroll-banner">
            <div>
              <p className="cd__enroll-title">Ready to Enroll?</p>
              <p className="cd__enroll-sub">
                Fill in your details and an ibots team member will confirm your batch within 24 hours.
              </p>
            </div>
            <button className="cd__enroll-btn" onClick={() => setShowEnrollForm(true)}>
              {trainingType === 'workshop' || trainingType === 'advanced_workshop'
                ? 'Enroll in This Workshop →'
                : 'Enroll in This Course →'}
            </button>
          </div>
        </div>

      </div>

      {showEnrollForm && (
        <CourseEnrollForm
          courseName={courseName}
          onClose={() => setShowEnrollForm(false)}
          isCollege={trainingType === 'college' || trainingType === 'vac'}
          isWorkshop={trainingType === 'workshop' || trainingType === 'advanced_workshop'}
          isVAC={trainingType === 'vac'}
          programme={{
            regular:           'Hands-on Training Programme',
            intensive:         'Daily Session Training',
            camp:              'Hands-on Training Camp',
            college:           'Hands-on Training Programme',
            workshop:          'Workshop (Regular)',
            advanced_workshop: 'Workshop (Advanced)',
            vac:               'Value Added Courses',
          }[trainingType] || ''}
        />
      )}
    </div>
  );
}

export default CourseDetail;
